import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from '../../icons/close';

import styles from './menu.module.css';

interface MenuItemProps extends React.ComponentProps<'div'> {
  label?: React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClose?: () => void;
}

export function MenuHeader({ label, onClick, onClose, leftIcon, rightIcon, ...props }: MenuItemProps) {
  const { t } = useTranslation();

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      if (onClose) {
        e.stopPropagation();
        onClose();
      }
    },
    [onClose]
  );

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div {...props} className={classNames(styles.menuItem, props.className)} onClick={onClick}>
      {leftIcon && <div className={classNames(styles.icon, styles.leftIcon)}>{leftIcon}</div>}

      <div className={styles.menuItemLabel}>
        <span className={styles.menuItemLabelText}>{label}</span>
      </div>

      {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}

      <button
        className={styles.close}
        onClick={handleClose}
        data-testid="close-button"
        aria-label={t('ui.menu.close.label')}
      >
        <CloseIcon />
      </button>
    </div>
  );
}
